import ServiceBase from "./ServiceBase"

const resource = "/persongroups"

export default
	{
		getPersonGroups(payload)
		{
			return ServiceBase.get(resource + "/list/" + payload.customerid + (payload.agreementid ? "/" + payload.agreementid : ""))
		},
		getPersonGroup(id)
		{
			return ServiceBase.get(resource + "/" + id)
		},
		updatePersonGroup(payload)
		{
			return ServiceBase.put(resource + "/" + payload.id, payload)
		},
		addPersonGroup(payload)
		{
			return ServiceBase.post(resource, payload)
		},
		deletePersonGroup(id)
		{
			return ServiceBase.delete(resource + "/" + id)
		}
	}